/**
 * Determines whether a Pages Router page requires authentication based on its
 * pathname and query params. Used by both `_app.tsx` (to conditionally load
 * GlobalModalProvider) and `UserProfileProvider` (to decide whether to fetch
 * the user profile).
 *
 * Authenticated routes:
 * - Any `/[workspace]/...` route (workspace param present, or raw pathname pattern)
 * - `/checkout/...`
 * - `/` (root index — redirects to user home)
 * - `/onboarding/business/0/...` (post-auth onboarding step)
 * - `/oauth/authorize` (OAuth consent — requires a logged-in user)
 */
export function requiresAuth({
  pathname,
  hasWorkspace,
}: {
  pathname: string;
  hasWorkspace: boolean;
}): boolean {
  return (
    hasWorkspace ||
    pathname.startsWith('/[workspace]') ||
    pathname.startsWith('/checkout') ||
    pathname === '/' ||
    pathname.startsWith('/onboarding/business/0') ||
    pathname === '/oauth/authorize'
  );
}
